import React, { useEffect } from "react";

import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Paper,
  Stack,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import FileIcon from "../../../../assets/FileIconBlue.svg";
import ViewIcon from "../../../../assets/ViewIcon.svg";
import DownloadIcon from "../../../../assets/DownloadBlueIcon.svg";
import DeleteIcon from "../../../../assets/DeleteRedIcon.svg";
import {
  fetchWaiverRequestDoc,
  uploadWaiverRequestDoc,
} from "../../../../services/network";

export default function DocumentList(props: any) {
  const { documents, dynamicConfig } = props;

  const [open, setOpen] = React.useState(false);
  const [currentDoc, setCurrentDoc] = React.useState<any>(null);
  const [fileURL, setFileURL] = React.useState<string>("");

  function handleClose() {
    setOpen(false);
    setCurrentDoc(null);
    setFileURL("");
  }

  function handleOpen(doc: any) {
    setOpen(true);
    setCurrentDoc(doc);
  }

  useEffect(() => {
    if (currentDoc) {
      viewFile(currentDoc);
    }
  }, [open]);

  async function viewFile(doc: any) {
    const filePath = doc?.documentPath?.split("sizerloan")[1] ?? "";

    const filePathUrl = `sizerloan${filePath}`;
    const urlData = await fetchWaiverRequestDoc(
      dynamicConfig?.fileDownloadUrl,
      {
        path: doc?.documentPath,
      },
    );

    const res = await fetch(urlData.data);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    setFileURL(urlData.data ?? "");
  }

  async function handleDownloadDocument(doc: any) {
    try {
      const urlData = await fetchWaiverRequestDoc(
        dynamicConfig?.fileDownloadUrl,
        {
          path: doc?.documentPath,
        },
      );
      window.open(urlData.data, "_blank");
    } catch (error) {
      console.error("Error downloading document:", error);
    }
  }

  function handleDeleteDocument(doc: any) {}

  return (
    <Box
      sx={{
        borderRadius: "14px",
        border: "1px solid #DBE2FF",
        background: "#FFF",
        display: "block",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "24px 24px 0 24px",
        gap: 16,
      }}
    >
      <h3
        style={{
          color: "#000",
          fontFamily: "Poppins",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "24px",
        }}
      >
        Uploaded Documents
      </h3>
      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        {documents?.map((doc: any, index: number) => (
          <Paper
            key={doc.id}
            variant="outlined"
            sx={{ mb: 2, borderRadius: 2, borderColor: "#e0e0e0" }}
          >
            <ListItem
              secondaryAction={
                <Stack direction="row" spacing={1}>
                  <IconButton
                    edge="end"
                    aria-label="view"
                    color="primary"
                    onClick={() => handleOpen(doc)}
                  >
                    <img src={ViewIcon} alt="View" />
                  </IconButton>
                  <IconButton
                    edge="end"
                    aria-label="download"
                    color="primary"
                    onClick={() => handleDownloadDocument(doc)}
                  >
                    <img src={DownloadIcon} alt="Download" />
                  </IconButton>
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    color="error"
                    onClick={() => handleDeleteDocument(doc)}
                  >
                    <img src={DeleteIcon} alt="Delete" />
                  </IconButton>
                </Stack>
              }
            >
              <ListItemIcon>
                <img
                  src={FileIcon}
                  alt="File"
                  style={{ marginRight: "16px", height: "38px", width: "38px" }}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: "#000",
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "21px",
                    }}
                  >
                    {doc?.documentName ?? ""}
                  </Typography>
                }
                secondary={
                  <Typography
                    sx={{
                      color: "#666",
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: 300,
                      lineHeight: "18px",
                    }}
                  >
                    {doc?.date
                      ? new Date(doc.date).toLocaleDateString()
                      : "26 March, 2026, 11:30 AM"}
                  </Typography>
                }
              />
            </ListItem>
          </Paper>
        ))}
      </List>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Preview: {currentDoc?.documentName ?? ""}
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ height: "80vh", p: 0 }}>
          <iframe
            src={fileURL ?? ""}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="Document Preview"
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
